<template>
  <div v-if="showCookieInfo" class="relative bg-petrol-50 p-4 text-sm border-b border-petrol-100">
    <button
      type="button"
      class="absolute top-4 right-4 cursor-pointer text-petrol-600 hover:text-petrol-800"
      :aria-label="t('close_aria_label')"
      @click="closeCookieInfo"
    >
      <span aria-hidden="true">X</span>
    </button>
    <span class="hidden md:block">
      <UiLanguagePlaceholder domain="SharedCookieInfo" name="text_long" />
      <a
        class="text-petrol-600 hover:text-petrol-800 underline ml-1"
        :href="links?.frequently_used_links?.privacy_policy?.url"
        @click.prevent="handleLinkClick"
        @auxclick.prevent="handleLinkClick"
        @keydown.enter.prevent="handleLinkClick"
      >
        <UiLanguagePlaceholder domain="SharedCookieInfo" name="view_details" />
      </a>
    </span>
    <span class="block md:hidden">
      <UiLanguagePlaceholder domain="SharedCookieInfo" name="text_short" />
      <a
        class="text-petrol-600 hover:text-petrol-800 underline ml-1"
        :href="links?.frequently_used_links?.privacy_policy?.url"
        @click.prevent="handleLinkClick"
        @auxclick.prevent="handleLinkClick"
        @keydown.enter.prevent="handleLinkClick"
      >
        <UiLanguagePlaceholder domain="SharedCookieInfo" name="view_details" />
      </a>
    </span>
  </div>
</template>
<script setup lang="ts">
import { WebStorage } from '~/utils/WebStorage'

const { translate: t } = useTranslations('SharedCookieInfo')
const { links } = usePortalData()
const webStorage = new WebStorage()
const showCookieInfo = ref(false)

onMounted(() => {
  // Check if user has already closed the cookie info
  const cookieInfo = webStorage.items.CookieInfo?.get() || {}

  // If user has explicitly hidden it and it's still valid, keep it hidden
  const expiry = cookieInfo.expires
  if (cookieInfo.hidden && expiry && new Date(expiry) > new Date()) {
    return
  }

  // Otherwise show the banner - either no preference or expired
  webStorage.items.CookieInfo.set({})
  showCookieInfo.value = true
})

const closeCookieInfo = () => {
  showCookieInfo.value = false

  // Set expiry (365 days)
  const expiryDate = new Date()
  expiryDate.setDate(expiryDate.getDate() + 365)

  // Store the preference using WebStorage
  webStorage.items.CookieInfo.set({
    hidden: true,
    expires: expiryDate.toISOString()
  })
}

const handleLinkClick = (event: MouseEvent | KeyboardEvent) => {
  // Check if it was a middle-click (usually to open in new tab)
  const isMiddleClick = event.type === 'auxclick' && (event as MouseEvent).button === 1

  closeCookieInfo()

  // Then navigate appropriately
  if (!links?.frequently_used_links?.privacy_policy?.url) {
    return
  }
  if (isMiddleClick) {
    window.open(links.frequently_used_links.privacy_policy.url, '_blank')
    return
  }
  window.location.href = links.frequently_used_links.privacy_policy.url
}
</script>

